var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVideoCamera = function SvgVideoCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6787 5.30469H3.04317C1.6404 5.30469 0.492676 6.45241 0.492676 7.85518V16.4503C0.492676 17.8531 1.6404 19.0008 3.04317 19.0008H13.6787C15.0815 19.0008 16.2292 17.8531 16.2292 16.4503V7.85518C16.2292 6.4269 15.0815 5.30469 13.6787 5.30469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9167 6.70514C21.7637 6.73065 21.6107 6.80716 21.4832 6.88368L17.5044 9.17911V15.0962L21.5087 17.3917C22.2483 17.8253 23.1665 17.5702 23.6001 16.8306C23.7276 16.601 23.8041 16.346 23.8041 16.0654V8.18443C23.8041 7.24075 22.9114 6.4756 21.9167 6.70514Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3115,
    height: 23.3115,
    fill: "white",
    transform: "translate(0.492676 0.496094)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video-camera.4c7b2197.svg";
export { ForwardRef as ReactComponent };